import _ from 'lodash';
import { LocalStorageService } from '@eureka/services/src/storage-service';
import { SAVED_COLLAPSE_KEY } from '../constants';

export function useCachedCollapse() {
    const save = (value: boolean) => {
        LocalStorageService.set(SAVED_COLLAPSE_KEY, value);
    };

    const load = () => {
        return _.isBoolean(LocalStorageService.get(SAVED_COLLAPSE_KEY)) ? LocalStorageService.get(SAVED_COLLAPSE_KEY) : true;
    };

    const clear = () => {
        LocalStorageService.delete(SAVED_COLLAPSE_KEY);
    };

    return {
        save,
        load,
        clear,
    };
}
